import * as React from 'react';

interface IBalloonImageProps {
  imageUrl: string;
  title: string;
}

export function BalloonImage({ imageUrl, title }: IBalloonImageProps) {
  return <img src={imageUrl} alt={title} width={356} height={200} />;
}
